/** How people are invited when the import is added (step 4). */
export const INVITE_MODE = Object.freeze({
  NONE: 'none',
  ALL: 'all',
  WITH_ACCESS: 'with_access',
  SELECTED: 'selected',
});

/** Members that exist already but have not joined: the ones "Also invite" can reach. */
export const UNJOINED_MEMBER_STATUSES = Object.freeze(['invited', 'expired', 'not_invited']);
export const ALREADY_INVITED_STATUSES = Object.freeze(['invited', 'expired']);

/** What the admin decides about a possible duplicate in "Before you add them". */
export const DUPLICATE_RESOLUTION = Object.freeze({
  USE_EXISTING: 'use_existing',
  ADD_NEW: 'add_new',
  KEEP_OTHER: 'keep_other',
  KEEP_THIS: 'keep_this',
  KEEP_BOTH: 'keep_both',
});
/** Who a possible duplicate looks like: an existing member, or an earlier row of the file. */
export const DUPLICATE_KIND = Object.freeze({ MEMBER: 'member', FILE: 'file' });
/** Choices of the Admin and outside-domain items of "Before you add them". */
export const ADMIN_CHOICE = Object.freeze({ CONFIRM: 'confirm', MEMBER: 'member' });
export const DOMAIN_CHOICE = Object.freeze({ KEEP: 'keep', REMOVE: 'remove', UNDO: 'undo' });
